import { PUBLIC_URL } from '../env'

export const getPhenomenonUrl = (
  radarId = false,
  phenomenon,
  hideEdit = false,
) => {
  if (
    !!phenomenon &&
    !!phenomenon?.groups &&
    !!phenomenon?.groups?.length &&
    !phenomenon?.group
  ) {
    // phenomenon['group'] = phenomenon?.radarGroupId || phenomenon?.groups[0]
    phenomenon['group'] = phenomenon?.groups[0]
  }
  const { group, id } = phenomenon
  const hasGroup = phenomenon.hasOwnProperty('group')
  const groupUrl = hasGroup ? `group=${group}` : ''

  if (!radarId) {
    return `${PUBLIC_URL}/fp-phenomena/${id}${
      groupUrl.length ? `/?${groupUrl}` : ''
    }`
  }

  const urlParams = new URLSearchParams(window.location.search)
  const vsid = urlParams.get('vsid')

  // eslint-disable-next-line
  return `${PUBLIC_URL}/fp-phenomena/${id}${
    groupUrl.length ? `/?${groupUrl}` : ''
  }&radar=${radarId}&source_position=right&source_page=radar-view${
    groupUrl.length ? `&${groupUrl}` : ''
  }${hideEdit ? '&hideEdit=true' : ''}${vsid ? `&vsid=${vsid}` : ''}`
}
export const getScenarioUrl = (
  groupId = false,
  scenarioSetId,
  scenarioId,
  positionX = false,
  positionY = false,
) => {
  // eslint-disable-next-line
  return `${PUBLIC_URL}/fp-scenario-card/${groupId}/${scenarioSetId}/${scenarioId}`
}
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function normalisedTimeFormat(originalTime) {
  if (!!originalTime) {
    const originalTimeSplited = originalTime?.split('-')
    const year = originalTimeSplited[0]
    const month = originalTimeSplited[1]
    const day = originalTimeSplited[2].substring(0, 2)
    // const hour = originalTimeSplited[2].substring(3,8)

    return day + '.' + month + '.' + year
  }
}

export const isDevEnv = () => {
  if (process.env.NODE_ENV === 'development') {
    return true
  }
  return false
}

export function createScenarioFuturesTableFinal(matrix, scenarioData) {
  // Define the driver combinations and their corresponding scenario types, positions, and colors
  const scenarioTypeInfo = {
    a: {
      position: 0,
      color: '#016998',
      colorName: 'BLUE',
      label: 'A',
      className: 'typeA-SS',
    },
    b: {
      position: 1,
      color: '#E95757',
      colorName: 'RED',
      label: 'B',
      className: 'typeB-SS',
    },
    c: {
      position: 2,
      color: '#6FBF40',
      colorName: 'GREEN',
      label: 'C',
      className: 'typeC-SS',
    },
    d: {
      position: 3,
      color: '#ECAF3F',
      colorName: 'ORANGE',
      label: 'D',
      className: 'typeD-SS',
    },
  }

  const driverToScenarioMap = {
    '-1,-1': {
      type: 'a',
      description: 'Driver 1 negative, Driver 2 negative',
      driverValues: [-1, -1],
      index: 1,
    },
    '-1,1': {
      type: 'b',
      description: 'Driver 1 negative, Driver 2 positive',
      driverValues: [-1, 1],
      index: 2,
    },
    '1,1': {
      type: 'c',
      description: 'Driver 1 positive, Driver 2 positive',
      driverValues: [1, 1],
      index: 3,
    },
    '1,-1': {
      type: 'd',
      description: 'Driver 1 positive, Driver 2 negative',
      driverValues: [1, -1],
      index: 4,
    },
  }

  // Extract unique drivers and future states from matrix keys
  const drivers = new Set()
  const futureStates = new Set()

  Object.keys(matrix).forEach((key) => {
    const [driver, futureState] = key.split('-')
    drivers.add(driver)
    futureStates.add(futureState)
  })

  const driversArray = Array.from(drivers)
  const futureStatesArray = Array.from(futureStates)

  // Initialize the final result as an array with 4 null positions
  const scenarioFinal = [null, null, null, null]

  // Create a mapping of driver combinations to scenario IDs
  const driverToScenarioIdMap = {}
  scenarioData.forEach((scenario) => {
    if (scenario.content && Array.isArray(scenario.content.drivers)) {
      const driverKey = scenario.content.drivers.join(',')
      driverToScenarioIdMap[driverKey] = {
        id: scenario.id,
        scenario: scenario,
      }
    } else if (Array.isArray(scenario.drivers)) {
      // Check for drivers directly in the scenario object
      const driverKey = scenario.drivers.join(',')
      driverToScenarioIdMap[driverKey] = {
        id: scenario.id,
        scenario: scenario,
      }
    }
  })

  // Process each scenario in the input data
  scenarioData.forEach((scenario) => {
    const hasDriversInContent =
      scenario.content && Array.isArray(scenario.content.drivers)
    const hasDriversDirect = Array.isArray(scenario.drivers)

    if (hasDriversInContent || hasDriversDirect) {
      // Convert the drivers array to a string key
      const driverKey = hasDriversInContent
        ? scenario.content.drivers.join(',')
        : scenario.drivers.join(',')

      // Find which scenario type this corresponds to
      const scenarioMapping = driverToScenarioMap[driverKey]
      const scenarioType = scenarioMapping ? scenarioMapping.type : null

      if (scenarioType && scenarioTypeInfo[scenarioType]) {
        const typeInfo = scenarioTypeInfo[scenarioType]

        // Create a copy of the scenario with additional data
        const enhancedScenario = JSON.parse(JSON.stringify(scenario))

        // Add driver mapping information
        enhancedScenario.driverMapping = scenarioMapping

        // Add structured matrix data related to this scenario type
        const matrixCells = []

        Object.entries(matrix).forEach(([key, cell]) => {
          if (
            Array.isArray(cell.scenarios) &&
            cell.scenarios.includes(scenarioType)
          ) {
            const [driver, futureState] = key.split('-')

            // Find row and cell indices (1-based for user-friendly display)
            const rowIndex = driversArray.indexOf(driver) + 1
            const cellIndex = futureStatesArray.indexOf(futureState) + 1

            matrixCells.push({
              key: key,
              cell: `Cell ${cellIndex}`,
              content: cell.content,
              color: typeInfo.colorName,
              row: `Row ${rowIndex}`,
              driver: driver,
              futureState: futureState,
              _id: cell._id,
            })
          }
        })

        // Add the matrix cells to the scenario
        enhancedScenario.matrixCells = matrixCells

        // Keep the original matrix data for reference
        enhancedScenario.matrixData = Object.entries(matrix)
          .filter(
            ([_, cell]) =>
              Array.isArray(cell.scenarios) &&
              cell.scenarios.includes(scenarioType),
          )
          .reduce((acc, [key, cell]) => {
            acc[key] = { ...cell }
            return acc
          }, {})

        // Add the scenario type information
        enhancedScenario.scenarioType = scenarioType
        enhancedScenario.color = typeInfo.color
        enhancedScenario.colorName = typeInfo.colorName
        enhancedScenario.label = typeInfo.label
        enhancedScenario.className = typeInfo.className

        // Preserve the original ID - don't modify or override it
        // (Do nothing if id already exists)

        // Assign to the appropriate position in the array
        scenarioFinal[typeInfo.position] = enhancedScenario
      }
    }
  })

  // Now add matrixCells for all scenario types that appear in the matrix
  // but don't have corresponding scenario data
  const scenarioTypesInMatrix = new Set()

  Object.values(matrix).forEach((cell) => {
    if (Array.isArray(cell.scenarios)) {
      cell.scenarios.forEach((type) => {
        scenarioTypesInMatrix.add(type)
      })
    }
  })

  // For each scenario type in the matrix
  scenarioTypesInMatrix.forEach((type) => {
    const typeInfo = scenarioTypeInfo[type]
    if (typeInfo && scenarioFinal[typeInfo.position] === null) {
      // Find the driver mapping for this scenario type
      const scenarioMapping = Object.values(driverToScenarioMap).find(
        (mapping) => mapping.type === type,
      )

      // Look for a matching scenario ID based on driver combination
      let scenarioId = `scenario-${type}`
      let matchedScenario = null

      if (scenarioMapping && scenarioMapping.driverValues) {
        const driverKey = scenarioMapping.driverValues.join(',')
        if (driverToScenarioIdMap[driverKey]) {
          scenarioId = driverToScenarioIdMap[driverKey].id || scenarioId
          matchedScenario = driverToScenarioIdMap[driverKey].scenario
        }
      }

      // Create a basic structure for this scenario type
      const matrixCells = []

      Object.entries(matrix).forEach(([key, cell]) => {
        if (Array.isArray(cell.scenarios) && cell.scenarios.includes(type)) {
          const [driver, futureState] = key.split('-')

          // Find row and cell indices (1-based for user-friendly display)
          const rowIndex = driversArray.indexOf(driver) + 1
          const cellIndex = futureStatesArray.indexOf(futureState) + 1

          matrixCells.push({
            key: key,
            cell: `Cell ${cellIndex}`,
            content: cell.content,
            color: typeInfo.colorName,
            row: `Row ${rowIndex}`,
            driver: driver,
            futureState: futureState,
            _id: cell._id,
          })
        }
      })

      // If we matched a scenario from scenarioData, use more of its data
      if (matchedScenario) {
        const enhancedScenario = JSON.parse(JSON.stringify(matchedScenario))
        enhancedScenario.driverMapping = scenarioMapping
        enhancedScenario.matrixCells = matrixCells
        enhancedScenario.scenarioType = type
        enhancedScenario.color = typeInfo.color
        enhancedScenario.colorName = typeInfo.colorName
        enhancedScenario.label = typeInfo.label
        enhancedScenario.className = typeInfo.className

        // Leave the original ID alone - it should already be preserved from matchedScenario

        enhancedScenario.matrixData = Object.entries(matrix)
          .filter(
            ([_, cell]) =>
              Array.isArray(cell.scenarios) && cell.scenarios.includes(type),
          )
          .reduce((acc, [key, cell]) => {
            acc[key] = { ...cell }
            return acc
          }, {})

        scenarioFinal[typeInfo.position] = enhancedScenario
      } else {
        // Create a basic structure with just the matrix data if no scenario match
        scenarioFinal[typeInfo.position] = {
          scenarioType: type,
          color: typeInfo.color,
          colorName: typeInfo.colorName,
          label: typeInfo.label,
          className: typeInfo.className,
          driverMapping: scenarioMapping,
          matrixCells: matrixCells,
          id: scenarioId, // Use fallback ID for matrix-only scenarios
          matrixData: Object.entries(matrix)
            .filter(
              ([_, cell]) =>
                Array.isArray(cell.scenarios) && cell.scenarios.includes(type),
            )
            .reduce((acc, [key, cell]) => {
              acc[key] = { ...cell }
              return acc
            }, {}),
        }
      }
    }
  })

  return scenarioFinal
}

export function getCloseButton(parentClass, closeButtonClass, typeElementClass) {
  // Get the parent element
  const parentElement = document.querySelector(`.${parentClass}`);
  
  if (!parentElement) {
      console.error('Parent element not found');
      return null;
  }

  // Check if the type element exists within the parent
  const typeElement = parentElement.querySelector(`.${typeElementClass}`);
  
  if (typeElement) {
      // If the type element exists, find the close button within the parent
      const closeButton = parentElement.querySelector(`.${closeButtonClass}`);
      return closeButton;
  }

  console.warn('Type element not found within the parent');
  return null;
}